import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 8" fill="none" {...props}>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M7.823 2.06825C7.9205 1.97725 8.079 1.97725 8.1765 2.06825C8.274 2.15975 8.274 2.30725 8.1765 2.39875L4.427 5.93175C4.329 6.02275 4.1705 6.02275 4.073 5.93175L0.323 2.39875C0.274 2.35325 0.25 2.29325 0.25 2.23375C0.25 2.17375 0.274 2.11425 0.323 2.06825C0.4205 1.97725 0.579 1.97725 0.677 2.06825L4.25 5.44025L7.823 2.06825Z" stroke-width="0.5" />
	</svg>
);